const { fetchText, withAdditionalSearchParams } = require('./api');

exports.checkers = function (state, config) {

    const tools = require('form/tools')();
    const apiDelay = 600;

    var apis = makeApis(state.fields);

    return checkForErrors;


    function runApi(field, renderCallback) {

        var state = field.state;

        if (renderCallback) {
            state.api.time = Date.now();
            setTimeout(go, apiDelay);
        }

        function go() {
            var state = field.state;
            if (state.localErrors.length <= 0 &&
                state.api.time <= Date.now() - apiDelay) {

                state.api.result = {};
                var localAPi = apis[field.config.id];

                if (localAPi && state.value) {
                    state.api.running = true;
                    localAPi(trimValue(state.value), handler.bind(this), field);
                }
            }
        }

        function handler(result) {
            var state = field.state;
            if (trimValue(state.value) === result.value) {
                if (result.status) state.api.error = "";
                else state.api.error = result.errorMessage;

                state.api.result = result.result || {};
                state.api.running = false;

                renderCallback(false);
            }
        }
    }

    function checkForErrors(renderCallback) {
        var globalState = tools.makeGlobalState(state, config);

        state.fields.forEach(field => {
            var validators = field.validators;
            if (field.config.mandatory === false && isEmpty(field.state.value)) {
                field.state.localErrors = [];
                field.state.errors = [];
            }
            else if (validators) {
                var localErrors = runValidators(validators, field);
                field.state.localErrors = localErrors;
                field.state.errors = combineErrors(localErrors, field.state.api.error);

                runApi(field, renderCallback);
            }
        });

        function combineErrors(localErrors, apiError) {
            if (apiError) return [...localErrors, apiError];
            else return localErrors;
        }

        function runValidators(validators, field) {
            var errors = validators.map(checker => {
                if (Array.isArray(checker)) return runValidators(checker, field);

                var error = checker(field.state, field.config, globalState);
                if (!Array.isArray(error)) return error;
                else return runValidators(error, field);
            }).filter(value => value !== false && value !== undefined && value !== null);
            return flattenArray(errors);
        }

        function flattenArray(array) {
            return array.reduce((list, value) => {
                return list.concat(value);
            }, []);
        }

    }


    function makeApis(fields) {
        return fields.reduce((dict, field) => {
            var fieldConfig = field.config;
            if (fieldConfig.api) dict[fieldConfig.id] = makeApi(fieldConfig.api);
            return dict;
        }, {});
    }

    function makeCache() {
        var cache = {};

        function run(key, runner) {
            setTimeout(function () {
                runner(function (value) {
                    var state = cache[key];
                    state.status = "finished";
                    state.value = value;

                    trigger(key);
                });
            }, 0);
        }

        function create(key, runner, callback) {
            cache[key] = {
                status: "pending",
                listeners: [callback],
                value: null
            };

            run(key, runner);
        }

        function trigger(key) {
            var state = cache[key];

            var listeners = state.listeners.splice(0);

            listeners.forEach(listener => {
                listener(state.value);
            });
        }

        function listen(key, runner, callback) {
            var state = cache[key];
            if (state === undefined) {
                create(key, runner, callback);
            }
            else if (state.status === "pending") {
                state.listeners.push(callback);
            }
            else if (state.status === "finished") {
                callback(state.value);
            }
            else {
                throw new Error('OMG');
            }
        }

        return {
            listen: listen,
        };
    }


    function makeApi({ url, errorMessage }, fields) {
        var cache = makeCache();
        return function checkApi(value, callback, field) {

            cache.listen(value, function (callback) {
                apiAjax(url, value, errorMessage, callback, field);
            }, callback);
        }
    }

    function apiAjax(url, value, errorMessage, callback, field) {
        var mainFunctionParameterConfig = config;
        var { countryCode } = mainFunctionParameterConfig;
        var message = prepareApiMessage(field, countryCode);

        var isNewApi = url.indexOf("https://leazard-nettbureauas.netdna-ssl.com/") !== -1;
        if (isNewApi) {
            fetchText(withAdditionalSearchParams(url, message))
                .then(success)
                .catch(error);
        } else {
            fetchText(url, {
                method: "POST",
                headers: { Accept: "text/plain", "Content-Type": "application/json" },
                body: JSON.stringify(message),
            })
                .then(success)
                .catch(error);
        }


        function error(e) {
            sendStatus();
        }

        function sendStatus(status = true, result = {}) {
            callback({
                status: status,
                result: result,
                value: value,
                errorMessage: errorMessage
            });
        }

        function success(a) {
            try {
                var { status, result } = parseJSON(a);
                sendStatus(status, result);
            }
            catch (e) {
                if (typeof ENVIRONMENT !== "undefined" && ENVIRONMENT === 'development') {
                    sendStatus(true, { kommune: "SANDEFJORD", poststed: "Lillehammer" });
                }
                else sendStatus();
            }
        }
    }

    function parseJSON(json) {
        if (json.indexOf(")]}',") === 0) {
            return JSON.parse(json.slice(5));
        }
        else return JSON.parse(json);
    }

};


function prepareApiMessage(field, countryCode = null) {
    var key = field.config.id;
    var handler = {
        phone: preparePhoneMessage
    }[key] || prepareDefaultMessage;

    return handler(field, countryCode);
}

function prepareDefaultMessage(field, countryCode) {
    return {
        q: trimValue(field.state.value),
        country: countryCode || "NO",
    }
}


function preparePhoneMessage(field, countryCode) {
    var { state } = field;
    if (state.foreign) {
        return {
            q: trimValue(state.value),
        }
    }
    else return prepareDefaultMessage(field, countryCode);
}

function trimValue(value = "") {
    return String(value).trim();
}

function isEmpty(value) {
    return value === "" || value === null || value === undefined;
}
